export default {
  SET_CURRENCY_DATA(state, data) {
    state.currencies = data;
  },
};
